export default __webpack_public_path__ + "static/media/DOCUMENT_ICON.2924b3d0.svg";